import styled from "styled-components";
import { media } from "../../globalStyles";

export const LoginModule = styled.div`
  display: flex;
  flex-direction: column;
  width: 75%;
  height: 95% !important;
  margin-top: 50px;
  background-color: #0f1923ff;
  border: 4.5px solid #081019ff;
  ${media.mobile} {
    width: 90%;
  }
  ${media.tablet} {
    width: 85%;
  }
`;

export const LoginTopWrapper = styled.div`
  width: 95%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h1 {
    font-size: 18px;
    font-weight: 400;
  }
`;

export const LoginMiddle = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  border-bottom: 2px solid #614e20ff;
`;

export const LoginMiddleWrapper = styled.div`
  width: 95%;
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 40px !important;
  .inlink{
    text-decoration: none;
    color: #614e20ff;
    &:hover {
    transition: all 0.5s ease-in;
    transition: all 0.5s ease-out;
    border-bottom: 2px solid #614e20ff;
  }
  ${media.mobile} {
    font-size: 13px;
  }
`;

export const LoginBottom = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 70px;
  padding-bottom: 50px;
  form {
    width: 100%;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 10px;
  h2 {
    font-size: 16px;
    font-weight: 300;
    margin-right: 20px;
  }

  img {
    width: 200px;
    object-fit: cover;
  }
`;
export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const LabelBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  flex: 1;
  h2 {
    margin-top: 20px;
    font-size: 16px !important;
  }

  ${media.mobile} {
    display: none;
  }
`;

export const InputBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1.5;

  ${media.mobile} {
    margin-left: 10px;
  }
`;

export const MobileLabel = styled.h2`
  margin-top: 10px;
  font-size: 14px !important;
  ${media.tablet} {
    display: none;
  }
  ${media.desktop} {
    display: none;
  }
`;

export const Input = styled.input`
  width: 60%;
  background-color: whitesmoke;
  height: 30px;
  padding: 6px;
  border: none;
  margin-top: 20px;
  font-style: italic;
  &:focus {
    outline-color: rgb(55, 72, 90);
    outline-style: solid;
    outline-width: 3px;
  }
  ${media.mobile} {
    width: 96% !important;
    margin-top: 6px;
  }
  ${media.tablet} {
    width: 75%;
  }
`;

export const FormBottom = styled.div`
  width: 100%;
  display: flex;
`;

export const FormBottomLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  ${media.mobile} {
    display: none;
  }
`;
export const FormBottomRight = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1.5;
  margin-top: 5px;
  gap: 10px;
  ${media.mobile} {
    margin-left: 10px;
  }
`;

export const Checkbox = styled.div`
  display: flex;
  width: 45%;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: 45%;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;

export const Error = styled.p`
  color: red;
`;

export const LoaderContainer = styled.span`
  margin-top: -2px;
`;
